import React from "react";
import { Box, Button, Typography, IconButton, useTheme } from "@mui/material";
import { StyledBox, StyledUpoadBox } from "../../../styled";
import {
  MANUAL_UPLOAD_MODAL,
  PREDATASET_UPLOAD_MODAL,
} from "../../../constants";
import { openModal, closeModal } from "../../../store/slice/UISlice";
import VisionStudioSvg from "../../VisionStudioSvg";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store/store";
import manualAnnotate from "../../../assets/img/manual_annotate.svg";
import presetData from "../../../assets/img/preset_data.svg";

/**
 *
 * Component to upload the Images
 *
 */
interface ImageUploadProps {
  onClose: () => void; // Define the type for onClose
  taskType?: string;
  isImageUploader?: boolean;
  isAnnotate?: boolean;
}

const SelectImageUploadType: React.FC<ImageUploadProps> = ({
  taskType,
  isImageUploader,
  isAnnotate,
}) => {
  console.log(isImageUploader, isAnnotate);
  const dispatch: AppDispatch = useDispatch();
  const theme = useTheme();
  const handleUploadOpen = () => {
    dispatch(closeModal());
    dispatch(openModal({ name: PREDATASET_UPLOAD_MODAL, taskType: taskType }));
  };
  const handleManualUploadOpen = () => {
    dispatch(closeModal());
    dispatch(openModal({ name: MANUAL_UPLOAD_MODAL, taskType: taskType }));
  };

  return (
    <Box>
      <Typography
        sx={{
          fontSize: theme.typography.h6.fontSize,
          fontWeight: theme.typography.h5.fontWeight,
          //width: "100%",
          position: "absolute",
          top: "10px",
        }}
      >
        How is your dataset?
      </Typography>
      <StyledBox sx={{ backgroundColor: "#FFFFFF", marginTop: "20px" }}>
        <StyledUpoadBox
          id="selectUploadSection"
          sx={{
            display: "flex",
            margin: "0 56px",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-evenly",
            cursor: "pointer",
          }}
        >
          {/* Pre-set Data Side */}
          {isImageUploader && isAnnotate && (
            <>
              <Box
                sx={{ textAlign: "center", flex: "0 0 49%", padding: "3rem 0" }}
                onClick={handleUploadOpen}
              >
                <Box>
                  <IconButton>
                    <VisionStudioSvg icon={presetData} />
                  </IconButton>
                </Box>
                <Button variant="contained">Pre-sorted</Button>
              </Box>

              {/* Divider */}
              <Box sx={{ flex: "0 0 2px" }}>
                <div
                  style={{ border: "1px solid #A1A1A1", height: "20vh" }}
                ></div>
              </Box>
            </>
          )}

          {/* Manual Side */}
          <Box
            sx={{ textAlign: "center", flex: "0 0 49%", padding: "3rem 0" }}
            onClick={handleManualUploadOpen}
          >
            <Box>
              <IconButton>
                <VisionStudioSvg icon={manualAnnotate} />
              </IconButton>
            </Box>
            <Button variant="contained">Manual</Button>
          </Box>
        </StyledUpoadBox>
      </StyledBox>
    </Box>
  );
};

export default SelectImageUploadType;
